<template>
  <div class="login-content">
    <div class="ibf-h1-larger login-title">
      {{ connectionLost ? $t('login.networkError.title') : $t('login.licenseError.title') }}
    </div>
    <div class="login-subtitle">
      {{ connectionLost ? $t('login.networkError.subtitle') : $t('login.licenseError.subtitle') }}
    </div>
    <div class="login-form">
      <div class="login-input-fields icon-container">
        <!-- <propagate-loader v-if="loginRetryPending" :color="'#E12828'"></propagate-loader> -->
        <img
          v-if="!loginRetryPending"
          src="@/assets/images/error.png"
          class="error-icon"
          alt="Login Failed"
        />
      </div>
      <div class="login-buttons">
        <q-btn
          id="license-retry"
          rounded
          no-caps
          flat
          tabindex="0"
          :label="connectionLost ? $t('login.networkError.submitLabel') : $t('login.licenseError.submitLabel')"
          class="submit-button ibf-h4 incredi-button-ibx danger"
          :class="{ disabled: loginRetryPending }"
          :disabled="loginRetryPending"
          @click="retryLogin()"
        >
        </q-btn>
        <div id="login-support-link">
          <a :href="supportMailUrl">{{ $t('login.licenseError.supportLink') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { PropagateLoader } from '@saeris/vue-spinners';

export default {
  name: 'LicenseLockedForm',
  components: {
    // PropagateLoader,
  },
  props: {
    loginRetryPending: { type: Boolean, required: true },
    connectionLost: { type: Boolean, default: false },
  },
  events: ['retryLogin'],
  data() {
    return {
      supportMailUrl: process.env.VUE_APP_SUPPORT_MAIL,
    };
  },
  methods: {
    retryLogin() {
      this.$emit('retryLogin');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './commonLoginComponentsStyle';
#login-support-link {
  position: relative;
}
.login-subtitle {
  margin-top: 37px;
}
</style>
